// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__3K5C-","react-pagination-js-bootstrap":"Pagination_react-pagination-js-bootstrap__3CuY-"};